<template>
  <div>
    <button
      class="peak3d-layers"
      type="button"
      :title="$t('peak_3d.peak3_d_overlay.change_map_style')"
      :aria-label="$t('peak_3d.peak3_d_overlay.change_map_style_2')"
      @click="openMapStyles"
    >
      <span class="material-icons">layers</span>
    </button>
    <BaseMapStylesDialog />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';
import BaseMapStylesDialog from '../base_map_dialog/BaseMapStylesDialog.vue';

export default defineComponent({
  components: { BaseMapStylesDialog },

  methods: {
    openMapStyles() {
      const el = document.getElementById('map-styles-dialog');
      if (el) Modal.getOrCreateInstance(el).show();
    },
  },
});
</script>
